export { default as PoliticalExposedPerson } from './political-exposed-person';
